define('plugin/invoice/model/InvoiceRecurringProfileModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Invoice recurring profile model
     *
     * @class InvoiceRecurringProfileModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/invoice/recurring-profile-details/id',

        defaults: {
            id: null,
            start_datetime: '',
            last_payment_datetime: '',
            next_payment_datetime: '',
            cancellation_datetime: '',
            payment_processor: '',
            status: ''
        }

    });

});
